import React from "react";

import Section from "../../../HOC/Section";

const Kvkk = () => {
  return (
    <Section id="kvkk">
      <div className="container pt-2 pb-5">
        <div className="section-header pt-5 pb-5 text-center">
          <h3 className="section-title">
            <span>KVKK </span>
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h5 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  Aydınlatma Metni
                </button>
              </h5>
              <div
                id="flush-collapseOne"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <div class="inner-post-entry entry-content">
                    <h5 class="wp-block-heading">
                      <strong>
                        Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni
                      </strong>
                    </h5>
                    <p>
                      İş bu Aydınlatma Metni, www.furkanlenk.com (Bundan sonra
                      “site” olarak anılacaktır.) internet sitesi ile alakalı
                      olarak Kişisel Veri Sahipleri’nden ve/veya üçüncü
                      kişilerden elde edilen kişisel verilerin kullanımına
                      ilişkin olarak 6698 sayılı Kişisel Verilerin Korunması
                      Kanunu (“<strong>KVKK</strong>”) uyarınca veri sorumlusu
                      olan,&nbsp;
                      <strong>Uzman Klinik Psikolog Furkan LENK&nbsp;</strong>
                      tarafından kişisel verilerinizin toplanma şekilleri,
                      kişisel veri işleme faaliyetlerinin amaçları ve hukuki
                      nedenleri, kişisel veriler aktarılıyorsa buna ilişkin
                      esaslar ve veri sahibi olarak haklarınız konularında
                      şeffaf bir şekilde sizleri bilgilendirmek ve aydınlatmak
                      amacıyla hazırlanmıştır.
                    </p>
                    <p>
                      KVKK uyarınca kişisel veri sahibi olarak paylaştığınız
                      Kişisel Verileriniz Veri Sorumlusu olarak belirlenen
                      Şirket tarafından aşağıda belirtilen kapsamda toplanacak
                      ve işlenebilecektir.
                    </p>
                    <p>
                      <strong>1.TANIMLAR ve KISALTMALAR</strong>
                    </p>
                    <p>İşbu Aydınlatma Metni’nde geçen;</p>
                    <p>
                      <strong>
                        Şirket :&nbsp;
                        <strong>Uzman Klinik Psikolog Furkan LENK</strong>
                      </strong>
                    </p>
                    <p>
                      Serhat Mahallesi, Timurpaşa Sokak Double Tower KayaKent
                      Sitesi. A Blok, Kat:3 No:39, 65100 İpekyolu/Van
                    </p>
                    <p>
                      <strong>Kişisel Veri :</strong>&nbsp;Kimliği belirli veya
                      belirlenebilir gerçek kişiye ilişkin her türlü bilgiyi,
                    </p>
                    <p>
                      <strong>Kişisel Verilerin İşlenmesi :&nbsp;</strong>
                      Kişisel verilerin tamamen veya kısmen otomatik olan ya da
                      herhangi bir veri kayıt sisteminin parçası olmak kaydıyla
                      otomatik olmayan yollarla elde edilmesi, kaydedilmesi,
                      depolanması, muhafaza edilmesi, değiştirilmesi, yeniden
                      düzenlenmesi, açıklanması, aktarılması, devralınması, elde
                      edilebilir hâle getirilmesi, sınıflandırılması ya da
                      kullanılmasının engellenmesi gibi veriler üzerinde
                      gerçekleştirilen her türlü işlemi,
                    </p>
                    <p>
                      <strong>Kişisel Veri Sahibi :</strong>&nbsp;Kişisel verisi
                      işlenen gerçek kişiyi,
                    </p>
                    <p>
                      <strong>KVKK :</strong>&nbsp;7 Nisan 2016 tarihinde Resmî
                      Gazete’ de yayınlanarak yürürlüğe giren 6698 sayılı
                      Kişisel Verilerin Korunması Kanunu’nu,
                    </p>
                    <p>
                      <strong>Veri İşleyen :</strong>&nbsp;Veri sorumlusunun
                      verdiği yetkiye dayanarak onun adına Kişisel Verileri
                      işleyen gerçek veya tüzel kişiyi,
                    </p>
                    <p>
                      <strong>Veri Sorumlusu :</strong>&nbsp;Kişisel Verilerin
                      işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt
                      sisteminin kurulmasından ve yönetilmesinden sorumlu olan
                      gerçek veya tüzel kişi
                    </p>
                    <p>
                      <strong>İnternet Sitesi/Site</strong>&nbsp;:
                      www.furkanlenk.com ‘u ifade eder.
                    </p>
                    <p>
                      <strong>2.İŞLENEN KİŞİSEL VERİLER</strong>
                    </p>
                    <p>
                      Şirket ile aranızdaki ilişkiye bağlı olarak işlenen ve
                      kişisel verilerinizin çeşitleri ve sayıları işlenme
                      nedenine göre değişiklik gösterecek olmakla birlikte;
                      Şirket ile paylaştığınız yahut Şirket tarafından üçüncü
                      kişilerden elde edilen Kişisel Veriler, aşağıdakilerden
                      ibarettir.
                    </p>
                    <p>
                      Kişisel verileriniz KVKK m. 4’te belirlenen genel ilkeler
                      uyarınca, hukuka ve dürüstlük kurallarına uygun, doğru ve
                      gerektiğinde güncel, belirli, açık ve meşru amaçlar için,
                      işlendikleri amaçla bağlantılı, sınırlı ve ölçülü ve
                      ilgili mevzuatta öngörülen veya işlendikleri amaç için
                      gerekli olan süre kadar muhafaza edilerek işlenmektedir.
                    </p>
                    <p>
                      {" "}
                      Kişisel veriler, KVKK’ nın 5. maddesi uyarınca Kişisel
                      Veri Sahibi’ nin açık rızası olmaksızın işlenemez. Ancak
                      yine aynı madde hükmüne göre aşağıdaki şartlardan birinin
                      varlığı hâlinde, Veri Sahibi’ nin açık rızası aranmaksızın
                      kişisel verilerinin işlenmesi mümkündür:
                    </p>
                    <ul>
                      <li>Kanunlarda açıkça öngörülmesi,</li>
                      <li>
                        Fiili imkânsızlık nedeniyle rızasını açıklayamayacak
                        durumda bulunan veya rızasına hukuki geçerlilik
                        tanınmayan kişinin kendisinin ya da bir başkasının
                        hayatı veya beden bütünlüğünün korunması için zorunlu
                        olması,
                      </li>
                      <li>
                        Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                        ilgili olması kaydıyla, sözleşmenin taraflarına ait
                        kişisel verilerin işlenmesinin gerekli olması,
                      </li>
                      <li>
                        {" "}
                        Veri Sorumlusu’ nun hukuki yükümlülüğünü yerine
                        getirebilmesi için zorunlu olması,
                      </li>
                      <li>
                        Kişisel verinin, Veri Sahibi’ nin kendisi tarafından
                        alenileştirilmiş olması,
                      </li>
                      <li>
                        Bir hakkın tesisi, kullanılması veya korunması için veri
                        işlemenin zorunlu olması,
                      </li>
                      <li>
                        Kişisel Veri Sahibi’ nin temel hak ve özgürlüklerine
                        zarar vermemek kaydıyla, Veri Sorumlusu’ nun meşru
                        menfaatleri için veri işlenmesinin zorunlu olması.
                      </li>
                    </ul>
                    <p>
                      <strong>
                        3.KİŞİSEL VERİLERİN İŞLENMESİNE İLİŞKİN GENEL İLKELER,
                        KİŞİSEL VERİLERİN İŞLENME ŞARTLARI ve AMAÇLARI
                      </strong>
                    </p>
                    <p>
                      Kişisel verileriniz KVKK m. 4’te belirlenen genel ilkeler
                      uyarınca, hukuka ve dürüstlük kurallarına uygun, doğru ve
                      gerektiğinde güncel, belirli, açık ve meşru amaçlar için,
                      işlendikleri amaçla bağlantılı, sınırlı ve ölçülü ve
                      ilgili mevzuatta öngörülen veya işlendikleri amaç için
                      gerekli olan süre kadar muhafaza edilerek işlenmektedir.
                    </p>
                    <p>
                      Kişisel veriler, KVKK’ nın 5. maddesi uyarınca Kişisel
                      Veri Sahibi’ nin açık rızası olmaksızın işlenemez. Ancak
                      yine aynı madde hükmüne göre aşağıdaki şartlardan birinin
                      varlığı hâlinde, Veri Sahibi’ nin açık rızası aranmaksızın
                      kişisel verilerinin işlenmesi mümkündür:
                    </p>
                    <ul>
                      <li>Kanunlarda açıkça öngörülmesi,</li>
                      <li>
                        Fiili imkânsızlık nedeniyle rızasını açıklayamayacak
                        durumda bulunan veya rızasına hukuki geçerlilik
                        tanınmayan kişinin kendisinin ya da bir başkasının
                        hayatı veya beden bütünlüğünün korunması için zorunlu
                        olması,
                      </li>
                      <li>
                        Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                        ilgili olması kaydıyla, sözleşmenin taraflarına ait
                        kişisel verilerin işlenmesinin gerekli olması,
                      </li>
                      <li>
                        Veri Sorumlusu’ nun hukuki yükümlülüğünü yerine
                        getirebilmesi için zorunlu olması,
                      </li>
                      <li>
                        Kişisel verinin, Veri Sahibi’ nin kendisi tarafından
                        alenileştirilmiş olması,
                      </li>
                      <li>
                        Bir hakkın tesisi, kullanılması veya korunması için veri
                        işlemenin zorunlu olması,
                      </li>
                      <li>
                        Kişisel Veri Sahibi’ nin temel hak ve özgürlüklerine
                        zarar vermemek kaydıyla, Veri Sorumlusu’ nun meşru
                        menfaatleri için veri işlenmesinin zorunlu olması.
                      </li>
                    </ul>
                    <p>
                      Şirket, işbu Aydınlatma Metni’ ne konu kişisel
                      verilerinizi mevzuattan kaynaklı yükümlülüklerin yerine
                      getirilmesi, websitemiz tarafından sunulan ürün ve
                      hizmetlerden ilgili kişileri faydalandırmak için gerekli
                      çalışmaların iş birimleri tarafından yapılması ve ilgili
                      iş süreçlerinin yürütülmesi, websitemiz tarafından
                      yürütülen hizmet faaliyetlerinin gerçekleştirilmesi için
                      ilgili iş birimleri tarafından gerekli çalışmaların
                      yapılması ve buna bağlı iş süreçlerinin yürütülmesi,
                      websitemizin ticari ve/veya iş stratejilerinin planlanması
                      ve icrası, websitemiz ile iş ilişkisi içerisinde olan
                      ilgili kişilerin hukuki, teknik ve ticari-iş güvenliğinin
                      temini ile tarafımızın sunduğu ürün ve hizmetlerin ilgili
                      kişilerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarına
                      göre özelleştirilerek ilgili kişilere önerilmesi ve
                      tanıtılması için gerekli olan aktivitelerin planlanması ve
                      icrası, İlgililerin olası hak ve alacak taleplerinin
                      tesisi Yetkili kuruluşlara mevzuattan kaynaklı bilgi
                      verilmesi, Ziyaretçi kayıtlarının oluşturulması ve takibi,
                      Şirketimiz, çağrı merkezimiz ya da internet sitelerimiz
                      ile sosyal medya sayfalarımız veya ve bunlarla sınırlı
                      olmamak üzere her türlü kanallar aracılığı ile Tüketicinin
                      Korunması Hakkında Kanun, diğer yasal mevzuat kapsamında,
                      yükümlülüklerin yerine getirilmesini sağlamak, Müşterilere
                      daha iyi hizmet verebilme, çeşitli avantajlar sağlayıp
                      sunma, satış, pazarlama, bilgilendirme, promosyonlar
                      hakkında bilgi verebilme, kampanya ve koşulları hakkında
                      bilgi sağlama, anket, müşteri memnuniyet araştırmalarını
                      yapabilme, satın alma işlemlerinizi sağlama hızlandırma,
                      siparişlerinizi alma ve teslim edebilme, Müşterilere
                      yönelik kampanyaların oluşturulması, hedef kitle
                      belirlenmesi, Müşteri hareketlerinin takip edilerek
                      kullanıcı deneyimini arttırıcı faaliyetlerin yürütülmesi
                      ve alışveriş sitemize ait internet sitesi ile mobil
                      uygulamanın işleyişinin geliştirilmesi ve müşteri
                      ihtiyaçlarına göre kişiselleştirilmesi, doğrudan ve
                      doğrudan olmayan pazarlama, kişiye özel pazarlama ve
                      yeniden pazarlama faaliyetlerinin yürütülmesi, kişiye özel
                      segmentasyon, hedefleme, analiz ve şirket içi raporlama
                      faaliyetlerinin yürütülmesi, pazar araştırmaları, Müşteri
                      memnuniyeti aktivitelerinin planlanması ve icrası ile
                      müşteri ilişkileri yönetimi süreçlerinin planlanması ve
                      icrası amaçlarıyla dahil olmak üzere dahil olmak üzere
                      sitemizin ürün ve/veya hizmetlerinin satış ve pazarlama
                      süreçlerinin planlanması ve icrası, sitemizin sunduğu ürün
                      ve/veya hizmetlere bağlılık oluşturulması ve/veya
                      arttırılması süreçlerinin planlanması ve icrası
                      amaçlarıyla işlemektedir.
                    </p>{" "}
                    <p>
                      <strong>
                        4.KİŞİSEL VERİLERİN TOPLANMA YÖNTEMLERİ ve HUKUKİ
                        SEBEPLERİ
                      </strong>
                    </p>{" "}
                    <p>Kişisel Verileriniz, Şirket tarafından</p>{" "}
                    <p>
                      www.furkanlenk.com, E-mail, çağrı merkezi, kamera kaydı,
                      ses kaydı, mobil uygulama gibi kanallarla KVKK tarafından
                      öngörülen temel ilkelere uygun olarak, KVKK’ nın 5. ve 6.
                      maddelerinde belirtilen Kişisel veri işleme şartları
                      kapsamında işbu Aydınlatma Metni’ nde belirtilen amaçlarla
                      toplanabilmekte, işlenebilmekte ve aktarılabilmektedir.
                    </p>{" "}
                    <p>
                      İşbu Aydınlatma Metni’ ne konu kişisel verileriniz bir
                      sözleşmenin kurulması veya ifasıyla doğrudan doğruya
                      ilgili olması ve Veri Sorumlusu’ nun meşru menfaatleri
                      için gerekli olması hukuki sebepleri dayanak alınarak
                      işlenmektedir.
                    </p>{" "}
                    <p>
                      <strong>
                        5.KİŞİSEL VERİLERİN AKTARILMASI, AKTARIM AMAÇLARI ve
                        SÜRELER
                      </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h5 class="accordion-header">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  KVKK Metni Bilgilendirme Metni
                </button>
              </h5>
              <div
                id="flush-collapseTwo"
                class="accordion-collapse collapse"
                data-bs-parent="#accordionFlushExample"
              >
                <div class="accordion-body">
                  <article
                    id="post-364"
                    class="post-364 page type-page status-publish hentry"
                  >
                    {" "}
                    <div class="penci-page-header">
                      {" "}
                      <h5 class="entry-title">
                        KVKK METNİ BİLGİLENDİRME METNİ
                      </h5>{" "}
                    </div>{" "}
                    <div class="penci-hide-tagupdated">
                      {" "}
                      <span class="author-italic author vcard">
                        Uzman Klinik Psikolog Hanife Aygün
                      </span>{" "}
                      <time
                        class="entry-date published"
                        datetime="2022-03-16T08:23:01+03:00"
                      >
                        29 Mayıs 2022
                      </time>{" "}
                    </div>{" "}
                    <div class="post-entry blockquote-style-1 page-has-margin">
                      {" "}
                      <div class="inner-post-entry entry-content">
                        {" "}
                        <p>
                          Değerli Danışanlarımız;&nbsp;
                          <strong>Uzman Klinik Psikolog Hanife AYGÜN</strong>
                          &nbsp;olarak 6698 sayılı “
                          <strong>Kişisel Verilerin Korunması Kanunu</strong>”
                          kapsamında, uygulamalarımız ve haklarınız ile ilgili
                          sizleri bilgilendirmek isteriz. 6698 sayılı Kişisel
                          Verilerin Korunması Kanunu hükümleri ve ilgili
                          düzenlemeler gereği (“KVKK Düzenlemeleri”) kimliğinizi
                          belirli veya belirlenebilir kılan her türlü bilginiz,
                          özel nitelikli kişisel verileriniz de dahil olmak
                          üzere, Kişisel Veri olarak nitelendirilmekte ve Veri
                          Sorumlusu sıfatıyla Uzman Klinik Psikolog Furkan LENK
                          tarafından aşağıda açıklandığı kapsamda ve mevzuat
                          tarafından emredilen sınırlar çerçevesinde
                          işlenmektedir. “Kişisel Verilerinizin İşlenmesi” bu
                          verilerin elde edilmesi, kaydedilmesi, depolanması,
                          muhafaza edilmesi, değiştirilmesi, yeniden
                          düzenlenmesi, açıklanması, aktarılması, devralınması,
                          elde edilebilir hale getirilmesi, sınıflandırılması ya
                          da kullanılmasının engellenmesi gibi veriler üzerinde
                          gerçekleştirilen her türlü işlemi ifade etmektedir.
                        </p>{" "}
                        <ul>
                          <li>
                            1-Kişisel Verilerinizin İşlenme Amacı, İşlenen
                            Kişisel Verileriniz Tarafınıza ait kişisel bilgiler,
                            onay ve/veya imzanızla tanzim edilen tüm
                            sözleşmeler/bilgilendirme formları ve sair
                            belgelerle, elektronik onay ve/veya imzanız ile
                            yapacağınız bildirimlerle, Genel Müdürlüğümüz,
                            fiziki ortamlar, çağrı merkezleri, internet
                            siteleri, mobil uygulamalar, internet işlemleri,
                            sosyal medya ve diğer kamuya açık mecralar,
                            kullanıcı görüşmeleri, adli kayıtların taranması,
                            piyasa istihbaratı, Kimlik Paylaşım Sistemi, SMS
                            kanalları, internet sitelerine yapılan dijital
                            başvurular, tüm mobil uygulamalarımız, satış
                            ekiplerine yapılan yazılı/dijital başvurular, çağrı
                            merkezi hizmeti alınan şirketler gibi yöntemler ile
                            Sizinle iletişime geçilen veya ileride iletişime
                            geçebilecek sözlü, yazılı, görüntülü, ses kaydı veya
                            elektronik kanallar yoluyla tamamen veya kısmen
                            otomatik olan ya da herhangi bir veri kayıt
                            sisteminin parçası olarak toplanmakta ve Kanunun
                            belirtilen hukuka uygunluk sebepleri çerçevesinde,
                            sözleşmenin ifası ve yasal yükümlülüklerin yerine
                            getirilmesi amacıyla saklanmaktadır. Bu hukuki
                            sebeple toplanan kişisel verileriniz 6698 sayılı
                            Kişisel Verilerin Korunması Kanunu’nun 5. ve 6.
                            maddelerinde belirtilen kişisel veri işleme şartları
                            ve amaçları kapsamında işlenebilmekte ve
                            aktarılabilmektedir.
                          </li>
                          <li>
                            2-Kişisel Verilerin İşlenmesinde Hukuki Sebepler ve
                            Rıza Şayet daha önceden alınmış rıza ve izniniz
                            mevcut değilse, yasal zorunluluk gereği izninizi
                            talep edeceğimiz durumlarda, web sitemizde yer alan
                            kişisel verileriniz ile ilgili izin alanında veya
                            üyelik sayfasında web sitesinde izin kutucuklarının
                            işaretlenmesi ve onaylanması suretiyle izin
                            verebileceksiniz. Bu kapsamda, Uzman Klinik Psikolog
                            Furkan LENK tarafından sizlere yönelik sağlanacak
                            ürün ve hizmet avantajlarından yaralanma ve haberdar
                            olma iradenizi ortaya koyarak Uzman Klinik Psikolog
                            Furkan LENK ile paylaştığınız kişisel verilerinizin,
                            sizlere çeşitli avantajların sağlanıp sunulabilmesi
                            ve özel reklam, satış, pazarlama, anket ve benzer
                            amaçlı her türlü fiziksel ve elektronik iletişim
                            yapılması ve diğer iletişim mesajlarının
                            gönderilmesi amacıyla; toplanmasına, saklanmasına,
                            işlenmesine, kullanılmasına, aktarımına dair de
                            izniniz talep edilmektedir. İzinlerinizi geri almak
                            için her zaman izin verdiğiniz yöntemlerle Uzman
                            Klinik Psikolog Furkan LENK’e başvurabilirsiniz.
                          </li>
                          <li>
                            3-Kişisel Verilerin Paylaşımı ve Aktarımı Uzman
                            Klinik Psikolog Furkan LENK tarafından işlenen
                            kişisel verileriniz, mevzuatta belirlenen güvenlik
                            ve gizlilik esasları uyarınca yeterli ve etkili
                            önlemler alınmak kaydıyla, yasal olarak aktarılması
                            gereken idari ve resmi makamlara, faaliyetlerimizi
                            yürütmek üzere dışarıdan hizmet alınan üçüncü
                            taraflara, işbirliği yaptığımız, program ortağı
                            kurum, kuruluş, işbirliği yapılan yurtiçi/yurtdışı
                            kuruluşlara, hizmet/destek/danışmanlık alınan ya da
                            proje/program ortağı olunan
                            yurtiçi/yurtdışı/uluslararası kuruluşlar, güvenlik,
                            çağrı merkezi gibi alanlarda destek aldığımız üçüncü
                            kişilerle, alt yüklenicilere, bağımsız denetim ve
                            destek hizmeti alınan kuruluşlar gibi tüzel kişilere
                            ve işbirliği içerisinde olan üçüncü tarafların
                            hukuki ve ticari güvenliğinin teminen ve/veya
                            elektronik ve fiziksel ortamların güvenliğinin
                            sağlanması ile hukuki zorunluluklar nedeniyle ve
                            yasal sınırlamalar çerçevesinde aktarılabilecektir.
                            Tarafımızca, yurt dışına aktarılabilecek kişisel
                            verileriniz aşağıdaki gibidir: Kimlik Verisi: Adı,
                            Soyadı İletişim Verisi: Eposta, Telefonu, Adresi
                            Görsel ve İşitsel Veri: Gerçek kişiye ait fotoğraf
                            Diğer: Erişim tarih ve saati, Cihaz kimliği, İşletim
                            sistemi, Tarayıcı tipi ve IP adresi Uzman Klinik
                            Psikolog Furkan LENK olarak kişisel verilerinizi,
                            gerekli güvenlik önlemlerini almak kaydıyla Türkiye
                            içinde depolama, arşivleme, bilişim teknolojileri
                            desteği alınan sunucular gibi ortamlara aktarabilir
                            işleyebilir ve saklayabiliriz.
                          </li>
                          <li>
                            4-Kanun Kapsamındaki Haklarınız Kişisel veri
                            sahipleri olarak şirketin aşağıda bildirilen
                            adresine şahsen başvuru ile ya da noter aracılığıyla
                            veya hesap açılışı sırasında bildirdiğiniz ve Uzman
                            Klinik Psikolog Furkan LENK sisteminde kayıtlı
                            bulunan elektronik posta adresinizi kullanmak
                            suretiyle aşağıdaki bildirilen elektronik posta
                            adresine iletebilirsiniz. Şirketimize ileteceğiniz
                            başvurularınızın Türkçe olması esas olup, ilgili
                            başvurularınızda ad, soyad, T.C. kimlik numarası,
                            tebligata esas yerleşim yeriniz veya iş yeri
                            adresiniz, bildirime esas elektronik posta adresiniz
                            ile talep konunuzu bulunması zorunlu olup,
                            talebinize ilişkin bilgi ve belgelerin de
                            başvurunuza eklenmesi gerekmektedir. Başvurunuz
                            yazılı ise imza atmanız da yasal bir zorunluluktur.
                            Uzman Klinik Psikolog Furkan LENK talebin niteliğine
                            göre talebi en kısa sürede ve en geç otuz gün içinde
                            ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin
                            ayrıca bir maliyeti gerektirmesi hâlinde, Uzman
                            Klinik Psikolog Furkan LENK tarafından Kişisel
                            Verileri Koruma Kurulu’nca belirlenen tarifedeki
                            ücret alınacaktır. Kişisel veri işlenip
                            işlenmediğini öğrenme, Kişisel verileri işlenmişse
                            buna ilişkin bilgi talep etme, Kişisel verilerin
                            işlenme amacını ve bunların amacına uygun kullanılıp
                            kullanılmadığını öğrenme, Yurt içinde veya yurt
                            dışında kişisel verilerin aktarıldığı üçüncü
                            kişileri bilme, Kişisel verilerin eksik veya yanlış
                            işlenmiş olması hâlinde bunların düzeltilmesini
                            isteme ve bu kapsamda yapılan işlemin kişisel
                            verilerin aktarıldığı üçüncü kişilere bildirilmesini
                            isteme, 6698 sayılı Kanun ve ilgili diğer kanun
                            hükümlerine uygun olarak işlenmiş olmasına rağmen,
                            işlenmesini gerektiren sebeplerin ortadan kalkması
                            hâlinde kişisel verilerin silinmesini veya yok
                            edilmesini isteme ve bu kapsamda yapılan işlemin
                            kişisel verilerin aktarıldığı üçüncü kişilere
                            bildirilmesini isteme, İşlenen verilerin münhasıran
                            otomatik sistemler vasıtasıyla analiz edilmesi
                            suretiyle kişinin kendisi aleyhine bir sonucun
                            ortaya çıkmasına itiraz etme, Kişisel verilerin
                            kanuna aykırı olarak işlenmesi sebebiyle zarara
                            uğraması hâlinde zararın giderilmesini talep etme
                            haklarına sahiptir. Saygılarımızla,
                          </li>
                        </ul>{" "}
                        <p>
                          Yazılı başvurularda:&nbsp;
                          <strong>
                            Uzman Klinik Psikolog Furkan LENK &nbsp;
                          </strong>
                          : Serhat Mahallesi, Timurpaşa Sokak, Double Tower
                          KayaKent Sitesi A Blok Kat:3 No:39 İpekyolu/Van
                        </p>{" "}
                        <p>
                          Elektronik posta yoluyla
                          başvurularda:&nbsp;psikologfurkanlenk@gmail.com
                        </p>{" "}
                        <p>
                          Kişisel verilerinizin&nbsp;
                          <strong>Uzman Klinik Psikolog Furkan LENK</strong>
                          &nbsp;tarafından işlenmesine onay vermek için metnin
                          yanında yer alan “Kare Kutucuk” alanına tıklamanızı
                          rica ederiz.
                        </p>{" "}
                      </div>{" "}
                    </div>{" "}
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Kvkk;
